export default {"src":"/_next/static/media/enhanced_transparency.e4cf5c2b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};